import React from 'react'

function Icon() {
  return (
    <svg
      width="99px"
      height="71px"
      viewBox="0 0 99 71"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>wallet</title>
      <g id="Wallet-SVG" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="icons8-wallet_copy_2" transform="translate(1.000000, 1.000000)">
          <g
            id="Group-24"
            transform="translate(0.260417, 0.000000)"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <g
              id="Group-23"
              transform="translate(9.961835, 0.659050)"
              stroke="#FFC0C4"
              strokeWidth="2"
            >
              <path d="M38.7464451,19.0415757 L38.7464451,-4.54747351e-13" id="Line"></path>
              <path
                d="M69.3443131,33.7277207 L69.4129366,14.601402"
                id="Line"
                transform="translate(69.378625, 24.164561) rotate(51.000000) translate(-69.378625, -24.164561) "
              ></path>
              <path
                d="M5.72878698,28.7583031 L5.70966298,15.7555827"
                id="Line"
                transform="translate(5.719225, 22.256943) rotate(309.000000) translate(-5.719225, -22.256943) "
              ></path>
            </g>
            <path
              d="M67.2854307,18.4566133 L66.2173926,4.80698551"
              id="Line"
              stroke="#FFEFF0"
              strokeWidth="2"
              transform="translate(66.751412, 11.631799) rotate(26.000000) translate(-66.751412, -11.631799) "
            ></path>
            <path
              d="M86.1087792,49.8999946 L86.1395338,30.725206"
              id="Line"
              stroke="#FFEFF0"
              strokeWidth="3.24"
              transform="translate(86.124156, 40.312600) rotate(77.000000) translate(-86.124156, -40.312600) "
            ></path>
            <path
              d="M8.28452511,47.3727665 L8.55513722,32.06453"
              id="Line"
              stroke="#FFEFF0"
              strokeWidth="3.24"
              transform="translate(8.070515, 40.064530) rotate(283.000000) translate(-8.070515, -40.064530) "
            ></path>
            <path
              d="M31.0869864,23.1858433 L31.0332434,4.11920677"
              id="Line"
              stroke="#FFEFF0"
              strokeWidth="2"
              transform="translate(31.060115, 13.652525) rotate(335.000000) translate(-31.060115, -13.652525) "
            ></path>
          </g>
          <path
            d="M24.2604167,39.00268 L24.2604167,33.4265955 C24.2604167,30.9863281 26.0045573,29.4869792 28.6896164,28.9973958 L60.956217,23 C63.4041336,23 65.3854167,24.981283 65.3854167,27.4291997 L65.3854167,28.875 L28.4295242,32.768717 C28.8579097,33.5107432 29.9518229,34.75 32.606283,34.75 L66.831217,34.75 C69.2791336,34.75 71.2604167,36.731283 71.2604167,39.1791997 L71.2604167,65.5708003 C71.2604167,68.018717 69.2791336,70 66.831217,70 L28.6896164,70 C26.2416997,70 24.2604167,68.018717 24.2604167,65.5708003 L24.2604167,59.99732 C24.3400622,59.9991035 24.4199265,60 24.5,60 C30.298625,60 35,55.298625 35,49.5 C35,43.701375 30.298625,39 24.5,39 C24.4199265,39 24.3400622,39.0008965 24.2604167,39.00268 Z M63.4270833,56.2916667 C65.5919601,56.2916667 67.34375,54.5398768 67.34375,52.375 C67.34375,50.2101232 65.5919601,48.4583333 63.4270833,48.4583333 C61.2622065,48.4583333 59.5104167,50.2101232 59.5104167,52.375 C59.5104167,54.5398768 61.2622065,56.2916667 63.4270833,56.2916667 Z"
            id="Combined-Shape"
            fill="#FF636D"
            fillRule="nonzero"
          ></path>
          <g id="Shape-2" transform="translate(16.260417, 41.000000)">
            <path
              d="M8.5,-8.8817842e-16 C13.194125,-8.8817842e-16 17,3.805875 17,8.5 C17,13.194125 13.194125,17 8.5,17 C3.805875,17 0,13.194125 0,8.5 C0,3.805875 3.805875,-8.8817842e-16 8.5,-8.8817842e-16 Z M9.07163636,3 L7.08836364,3 L7.252,10.3636364 L8.908,10.3636364 L9.07163636,3 Z M8.08245455,14.6091818 C8.755,14.6091818 9.15918182,14.2483636 9.15918182,13.6420909 C9.15918182,13.0243636 8.755,12.6635455 8.08245455,12.6635455 C7.40418182,12.6635455 7,13.0243636 7,13.6420909 C7,14.2483636 7.405,14.6091818 8.08245455,14.6091818 Z"
              id="Combined-Shape"
              fill="#CC4F57"
              fillRule="nonzero"
            ></path>
            <g id="Group" transform="translate(7.000000, 3.000000)"></g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Icon
